module.exports = __webpack_public_path__ + "static/media/not_found.abc2b3f8.svg";